import React, { Component } from 'react'

import { CarouselProvider, Slider, Slide, ButtonNext, ButtonBack } from 'pure-react-carousel'
import 'pure-react-carousel/dist/react-carousel.es.css'
import { ScreenClass } from '../Grid'
import './styles.scss'
import Icon from '../Icon'

const visibleSlideMap = {
  'xs': 2,
  'sm': 3,
  'md': 4,
  'lg': 5,
  'xl': 6
}

const imageCache = {}

function importAll (r) {
  r.keys().forEach((key) => (imageCache[key] = r(key)))
}

importAll(require.context('../../../../src/assets/img/chains/', false, /\.(png|jpe?g|svg)$/))
const images = Object.entries(imageCache).map(module => module[1].default)

class HotelChainBanner extends Component {

  getImgClassnames (image) {
    if (/_bgw\.\w+$/.test(image[0])) {
      return ['filter-rm-bg-w']
    }
    return []
  }

  render () {
    return <div className={'hotel-chain-banner'}>
      <ScreenClass>
        {screenClass => {
          let visibleSlides = 6
          if (visibleSlideMap.hasOwnProperty(screenClass)) {
            visibleSlides = visibleSlideMap[screenClass]
          }
          return <CarouselProvider
            visibleSlides={visibleSlides}
            totalSlides={images.length}
            step={visibleSlides}
            dragStep={visibleSlides}
            isPlaying={true}
            interval={15000}
            isIntrinsicHeight={true}
            infinite={true}
          >
            <Slider>
              {
                Object.entries(imageCache).map(
                  (image, index) => <Slide key={index} index={index}>
                    <img src={image[1].default} alt={'partner-logo'}
                         className={this.getImgClassnames(image).join(' ')}/>
                  </Slide>)
              }
            </Slider>
            <ButtonBack className={'buttonBack'}>
              <Icon faClassName={'fa-arrow-left'} type={'fa'} background={'grey'}/>
            </ButtonBack>
            <ButtonNext className={'buttonNext'}>
              <Icon faClassName={'fa-arrow-right'} type={'fa'} background={'grey'}/>
            </ButtonNext>
          </CarouselProvider>
        }
        }
      </ScreenClass>
    </div>
  }
}

HotelChainBanner.defaultProps = {}
HotelChainBanner.propTypes = {}

export default HotelChainBanner
